import { render } from "./CustomerHeader.vue?vue&type=template&id=6e64daa6"
import script from "./CustomerHeader.vue?vue&type=script&lang=js"
export * from "./CustomerHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__